module.exports = __webpack_public_path__ + "img/xtools.1d336d01.svg";